<template>
  <div class="masthead"> 
    <div class="braning"> 
      <div>Tao家西雅图-美洲最佳援交中介 | 8年老牌 | 靠谱约炮</div>
      <div>Tao家 – 西雅图第一伴君品牌</div>
    </div> 
    <header >
        <!-- <img src="@/assets/Artboard-2.svg" srcset="@/assets/Artboard-2.svg" alt="顶部图片" />  -->
        
        <div class="logo">
          <img src="@/assets/300-252.svg" srcset="@/assets/300-252.svg" @click="targetHome" alt="西雅图桃桃私人会所" /> 
          <div class="logo-text">
            <span class="title-en">Tao – </span>
            <span class="title-ch">西雅图第一伴君品牌</span>
          </div>
        </div>
     
    
      <NavBar/>  
    </header>
  </div>
</template>

<script setup>
import NavBar from '@/components/NavBar.vue'
import { useRouter } from 'vue-router'; 
import { useStore } from 'vuex';
const router = useRouter();
const store = useStore();

function targetHome(){
  router.push('/');

  store.dispatch('updateActiveIndex', 0);
}
 
</script>

<style lang="scss" scoped>
// @import "@/assets/css/head.scss"; 


@media screen and (max-width: 767px){
  .masthead::after{  
      // height: 8rem !important;  
  } 
  header>.logo>.logo-text{
    // font-size: 24px!important;
    // transform: translate(-33%, -10%)!important;
    // left: 30%!important;
    // bottom: 1.5rem!important;
  }
} 

$underline-duration: 0.3s;
.masthead{
    position: relative; 
    top: 0 !important;   
    background:  #020221  url(@/assets/logobg.jpg) no-repeat  center center;
    background-size: cover; 
    // background: #020221 url(@/assets/logobg.png) repeat center center;
    // background-size: 100% 100%;
    

    .braning{
        justify-content: center;
        flex: 1 1 100%;
        display:flex;
        line-height: 0;
        font-size: 0;
    }

    header {
      max-width: calc(1300px - 100px);
      margin: 0 auto;
      background-color: var(--wpcomm-color-red);
      position: relative;  
      img {
        width: 300px;
        height: 252px;
      }
      .logo{  
        position: relative;    
        .logo-text{
          position: relative; 
          bottom: 3rem; 
          font-size: 30px;
          text-align: center;
          // font-weight: bold;
          background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
          -webkit-background-clip: text !important;
          -webkit-text-fill-color: transparent;
        }
      }
    
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0rem;
      left: 0;
      width: 100%;
      height: 4rem;
      background: #040435;  
    }
}


</style>